import { render } from "./RecensementDashboardPage.vue?vue&type=template&id=20573aa3&ts=true"
import script from "./RecensementDashboardPage.vue?vue&type=script&lang=ts"
export * from "./RecensementDashboardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__